import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";

import { SessionTimeoutService } from "./session-timeout.service";

/**
 * M-06 — Verifica o timeout absoluto de sessão antes de cada request HTTP.
 *
 * Se a sessão expirou (8h desde o login), o SessionTimeoutService força o logout/redirect
 * e o request é abortado (EMPTY) para não bater no backend com um token prestes a ser
 * invalidado. Quando não há marco de sessão (fluxo anônimo/externo por token, ou pré-login),
 * checkTimeout() é no-op e o request segue normalmente.
 */
@Injectable()
export class SessionTimeoutInterceptor implements HttpInterceptor {
    private sessionTimeout = inject(SessionTimeoutService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const expired = this.sessionTimeout.checkTimeout();
        if (expired) {
            // Sessão encerrada: aborta o request. O logout/redirect já foi disparado.
            return EMPTY;
        }
        return next.handle(request);
    }
}
